import { AiOutlinePieChart } from 'react-icons/ai';
import { Button, Input, Select } from 'antd';
import BonusCard from './BonusCard';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { createContext, useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import axios from '../../axios/axios';
import PageLoader from '../../components/PageLoader';
import LoaderComp from '../../components/LoaderComp';
import dayjs from 'dayjs';
import BonusSwitchBox from './BonusSwitchBox';
import FloatHeaderFilter from './FloatHeaderFilter';
import IntSwitchButton from './IntSwitchButton';
import { IMAGE_BASE_URL } from '../../common/Constants';

export const ProductInfoContext = createContext(null);

const SingleLoanProduct = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { prodId, year } = useParams();
  const initialYear = year ? Number(year) - 1 : null;
  const [comYearPos, setComYearPos] = useState(initialYear);
  const filterRef = useRef(null);
  const [floatHeader, setfloatHeader] = useState(false);
  const [interestCatg, setinterestCatg] = useState(true);
  const [bonusVal, setBonusVal] = useState('');
  const [interestKey, setInterestKey] = useState(0);
  const [interestId, setInterestId] = useState(null);
  const [largestDealerCommission, setLargestDealerCommission] = useState(null);

  const [filterItem, setFilterItem] = useState({
    keyword: '',
    sortOrder: 'desc',
  });
  const tokenId = localStorage.getItem('dealerModuleToken');
  const {
    data: productInfo,
    isLoading: pdLoad,
    isFetching: pdFetch,
  } = useQuery(
    'dealer-product',
    async () => {
      const resp = await axios.get(`/loan/product/info/${prodId}`, {
        headers: {
          Authorization: `Bearer ${tokenId}`,
        },
      });
      return resp?.data?.data;
    },
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setInterestId(data.interests[0].id);
      },
    }
  );
  let Interests = null;
  if (!pdLoad && !pdFetch) {
    Interests = productInfo.interests;
    Interests = Interests[interestKey];
  }
  const {
    data: InterestData,
    isLoading: intLoad,
    isFetching: intFetch,
    refetch: intRefetch,
  } = useQuery(
    [
      'interest-data',
      bonusVal,
      comYearPos,
      filterItem.keyword,
      filterItem.sortOrder,
      interestId,
      location.key,
    ],
    async ({ queryKey }) => {
      let [, bonus, comYear, keyword, sortOrder, interestId] = queryKey;

      const comYearNum = comYear === null ? 1 : comYear + 1;
      const bonusValSafe = bonus || '';

      const payload = {
        keyword,
        bonus: bonusValSafe,
        [`year${comYearNum}_fee`]: 'asc',
        sortKey: `year${comYearNum}_fee`,
        sortOrder,
      };

      localStorage.setItem('interestQueryPayload', JSON.stringify(payload));
      localStorage.setItem('selectedInterestID', interestId);
      localStorage.setItem('selectedYear', JSON.stringify(comYearNum));

      const resp = await axios.post(
        `/interest/bonus/info/${interestId}/${comYearNum}`,
        { payload },
        {
          headers: { Authorization: `Bearer ${tokenId}` },
        }
      );

      const data = resp?.data?.data;
      if (data && data.length > 0) {
        const sortedData = data.sort((a, b) => Number(b.dealercommision) - Number(a.dealercommision));
        setLargestDealerCommission(sortedData[0]?.agent);
      }

      return resp?.data?.data;
    },
    { refetchOnWindowFocus: false, enabled: !!interestId }
  );

  useEffect(() => { }, [largestDealerCommission]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const value = params.get("value") || "LT";
    if (!productInfo || !productInfo.interests) {
      console.log("productInfo not ready yet");
      return;
    }
    if (value === "LT") {
      setInterestKey(0);
      setinterestCatg(!interestCatg);
    } else {
      let iKey = interestKey === 0 ? 1 : 0;
      setInterestKey(iKey);
      setinterestCatg(interestCatg);
      setInterestId(productInfo.interests[iKey].id);
    }
  }, [location.search, productInfo]);

  useEffect(() => {
    const toggle = interestKey === 0 ? "LT" : "HT";
    updateUrlValue(toggle);
  }, [interestKey]);

  const updateUrlValue = (newValue) => {
    const url = new URL(window.location.href);
    url.searchParams.set("value", newValue);
    window.history.replaceState(null, "", url.toString());
  };

  const handleSwitchButton = () => {
    if (productInfo.interests.length < 2) {
      setInterestKey(0);
      setinterestCatg(!interestCatg);
    } else {
      let iKey = interestKey === 0 ? 1 : 0;
      setInterestKey(iKey);
      console.log("else part----------", iKey)
      setinterestCatg(!interestCatg);
      setInterestId(productInfo.interests[iKey].id);
    }
  };

  const handleYearComSwitch = (idx) => {
    setComYearPos(idx);
    const newYear = idx + 1;
    const { pathname, search } = window.location;
    const basePath = pathname.substring(0, pathname.indexOf("/loan-products"));
    const newUrl = `${basePath}/loan-products/${prodId}/${newYear}${search}`;
    window.history.replaceState(null, "", newUrl);
  };

  const handleBonus = (val, title, index) => {
    switch (val) {
      case 0:
        setBonusVal('');
        break;
      case 1:
        setBonusVal('1');
        break;
      case 2:
        setBonusVal('0');
        break;
      default:
        break;
    }
  };
  const handleSortBy = (val) => {
    setFilterItem({
      ...filterItem,
      sortOrder: val,
    });
  };
  useEffect(() => {
    const handleScroll = () => {
      if (filterRef.current) {
        const refpos = filterRef.current.getBoundingClientRect().bottom;
        if (refpos < -250) {
          setfloatHeader(true);
        } else {
          setfloatHeader(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <>
      {floatHeader && (
        <FloatHeaderFilter
          context={{
            interestCatg,
            filterItem,
            setFilterItem,
            comYearPos,
            setComYearPos,
            handleSwitchButton,
          }}
        />
      )}
      {pdFetch || pdLoad ? (
        <PageLoader />
      ) : (
        <ProductInfoContext.Provider
          value={{ productInfo, interestKey, setInterestKey, Interests }}
        >
          <div className='w-full min-h-screen bg-[#F5F5F5]'>
            <div className='bg-white'>
              <div className='top_head_sec flex items-center p-[25px_25px_15px_25px] max-[600px]:p-[25px_10px]'>
                <div
                  className='mr-[20px] cursor-pointer'
                  onClick={() => navigate(-1)}
                >
                  <img src='/images/left-circle.svg' alt='arrow' />
                </div>
                <h1 className='text-[#27272B] font-[700] text-[20px]'>
                  Loan Product Interest Rates
                </h1>
              </div>
              <div
                className='mt-[10px] p-[0_30px_20px_60px] max-[600px]:p-[0_15px_30px_25px] border-b border-[#EAEAEA]'
                ref={filterRef}
              >
                <div className='flex justify-between max-[1100px]:flex-wrap'>
                  <div className='max-[1100px]:w-full max-[1100px]:mb-[20px]'>
                    <div className='flex gap-[10px] max-[500px]:flex-wrap'>
                      <div>
                        <div className='flex items-center mb-[13px]'>
                          <span className='mr-[11px]'>
                            <img
                              src={`${IMAGE_BASE_URL}${productInfo.icon}`}
                              alt='bank logo'
                              className='w-[40px] h-[40px] object-cover rounded-[4px] bg-white'
                            />
                          </span>
                          <h2 className='text-[#0D062D] font-[700] text-[22px]'>
                            {productInfo.name}
                          </h2>
                        </div>
                        <div className='mt-[13px]'>
                          <p className='text-[#787486] min-w-[270px] max-w-full text-[13px] mb-[4px]'>
                            {Interests?.remarks1.substring(0, 50)}
                            {Interests?.remarks1.length > 50 ? '..' : null}
                          </p>
                          <p className='text-[#787486] min-w-[270px] max-w-full text-[13px] mb-[4px]'>
                            {Interests?.remarks2.substring(0, 50)}
                            {Interests?.remarks2.length > 50 ? '..' : null}
                          </p>
                        </div>
                      </div>
                      <div className='ml-[45px] max-[500px]:ml-[0px]'>
                        <span className='block text-[#0D062D] font-[800] text-[30px] mb-[7px]'>
                          {Interests.interest}%
                        </span>
                        {/* <span className='block text-[13px] text-[#0F59F9]'>
                          Bonus (
                          {Interests?.allagentbonuses
                            ? Interests?.allagentbonuses?.length
                            : 0}
                          )
                        </span> */}
                      </div>
                    </div>
                    <div className='mt-[20px]'>
                      <h3 className='text-[#27272B] text-[14px] mb-[15px] font-[700]'>
                        Select year of commission
                      </h3>
                      {Array.from({ length: 10 }).map((_, idx) => {
                        return (
                          <span
                            key={idx}
                            className={`select-none inline-block border border-[#C3D2E2] text-[12px]  p-[6px_17px] cursor-pointer rounded-[4px] mr-[10px] mb-[10px] ${idx === Number(comYearPos)
                              ? 'bg-[#0F59F9] text-white'
                              : 'text-[#263238]'
                              }`}
                            onClick={() => handleYearComSwitch(idx)}
                          >
                            {idx + 1}
                          </span>
                        );
                      })}
                    </div>
                  </div>
                  <div className='max-[1100px]:w-full max-[1100px]:flex max-[1100px]:items-end max-[1100px]:flex-wrap max-[1100px]:gap-[20px]'>
                    <IntSwitchButton
                      single
                      switchVal={interestCatg}
                      handleSwitchButton={handleSwitchButton}
                    />
                    {/* <div className='single_sw_Box'>
                      <BonusSwitchBox
                        title='Bonus'
                        tabs={[
                          { name: 'All', val: '' },
                          { name: 'Yes', val: '1' },
                          { name: 'No', val: '0' },
                        ]}
                        settingsHandle={handleBonus}
                        value={bonusVal}
                      />
                    </div> */}
                    <div className='text-end min-[1101px]:mt-[25px] max-[1100px]:text-start'>
                      <span className='inline-flex items-center p-[10px_15px] text-[#0F59F9] font-[600] text-[14px] border border-[#0F59F9] rounded-[4px] cursor-pointer'
                        onClick={() => {
                          navigate('/view-agent-chart', {
                            state: {
                              InterestData,
                              prodId: prodId,
                              agentId: largestDealerCommission,
                            }
                          })
                        }}
                      >
                        <AiOutlinePieChart className='text-[#0F59F9] text-[18px] mr-[12px]' />
                        Create agent chart
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='px-[35px] pb-[20px] max-[700px]:px-[20px] max-[400px]:px-[10px]'>
              <div className='flex items-center justify-between my-[30px] max-[1250px]:flex-wrap gap-x-[15px]'>
                <div className='max-[1250px]:w-full max-[1250px]:mb-[15px]'>
                  <h3 className='text-[#0D062D] text-[19px] font-[700] mr-[15px] max-[500px]:text-[16px] max-[400px]:pl-[5px]'>
                    Agent Loan Commission
                  </h3>
                </div>
                <div className='flex-[1] max-[1250px]:w-[50%]'>
                  <Input
                    prefix={
                      <img
                        src='/images/search.svg'
                        alt='search'
                        className='mr-[5px]'
                      />
                    }
                    placeholder='Search By Agent, Comm'
                    className='loan_com_search w-[320px] max-w-full max-[750px]:w-full'
                    value={filterItem.keyword}
                    onChange={(e) =>
                      setFilterItem({ ...filterItem, keyword: e.target.value })
                    }
                  />
                </div>
                <div className='max-[1250px]:w-[50%]'>
                  <div className='flex items-center max-[1250px]:justify-end'>
                    <span className='text-[#495159] font-[500] text-[13px] mr-[14px] max-[750px]:hidden'>
                      Sort by:
                    </span>
                    <Select
                      className='loan_com_select w-[255px] max-[750px]:w-full'
                      value={filterItem.sortOrder}
                      onChange={handleSortBy}
                      suffixIcon={
                        <img
                          src='/images/select_ar.svg'
                          alt='arrow'
                          className='mr-[6px]'
                        />
                      }
                      options={[
                        {
                          value: 'asc',
                          label: 'Loan Comm. (Low - High)',
                        },
                        {
                          value: 'desc',
                          label: 'Loan Comm. (High - Low)',
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
              {intFetch ? (
                <LoaderComp />
              ) : (
                <>
                  {InterestData.length > 0 ? (
                    InterestData.map((item, idx) => {
                      let startDate = item.startDate
                        ? dayjs(item.startDate)
                          .format('DD MMM YYYY')
                          .toUpperCase()
                        : null;
                      let endDate = item.endDate
                        ? dayjs(item.endDate)
                          .format('DD MMM YYYY')
                          .toUpperCase()
                        : null;
                      let agentInf = item.agentinfo;
                      return (
                        <div
                          key={idx}
                          className='com_agent_card bg-white rounded-[10px] p-[30px_40px] mb-[30px] max-[700px]:p-[30px_25px]'
                        >
                          <div className='flex justify-between items-center flex-wrap gap-[20px]'>
                            <div className='flex items-center flex-wrap gap-[15px_10px] max-[1170px]:w-full max-[1170px]:justify-between'>
                              <div className='flex items-center'>
                                <img
                                  src={`${IMAGE_BASE_URL}${agentInf.icon}`}
                                  alt='icon'
                                  className='w-[28px] h-[28px] object-contain bg-white rounded-[4px]'
                                />
                                <h4 className='text-[#0D062D] text-[17px] font-[700] mx-[12px]'>
                                  {agentInf.name}
                                </h4>
                              </div>
                              <p className='text-[12px] text-[#787486] flex items-center'>
                                <img
                                  src='/images/fi_calendar.svg'
                                  alt='calendar'
                                  className='mr-[7px]'
                                />
                                Publish date:{' '}
                                <strong className='ml-[5px] font-[600] text-[#0F0F0F]'>
                                  {startDate}{' '}
                                  <span className='mx-[4px]'>to</span> {endDate}
                                </strong>
                              </p>
                            </div>
                            <div className='flex items-center flex-wrap gap-[10px] max-[1170px]:w-full max-[1170px]:justify-between'>
                              <div className='flex items-center'>
                                <span className='text-[#0D062D] text-[16px] font-[500] mr-[15px]'>
                                  Dealer Commission
                                </span>
                                <span className='font-[800] text-[30px] text-[#0D062D] mr-[18px]'>
                                  {item.dealercommision}%
                                </span>
                              </div>
                              {/* {pagePermission?.create_permission == 1 && (
                                                                <Button
                                                                    type="primary"
                                                                    size="large"
                                                                    className="loan_com_btn"
                                                                >
                                                                    Select
                                                                </Button>
                                                            )} */}
                            </div>
                          </div>
                          <div className='mt-[15px]'>
                            <label className='block text-[#27272B] font-[700] text-[13px] mb-[12px]'>
                              Admin Fee
                            </label>
                            {item.adminfees.map((item, idx) => {
                              return (
                                <div
                                  className='min-w-[296px] mb-[10px] max-w-full rounded-[4px] bg-[#F4F4F4] rounded-[8px] border border-[#E0E0E0] p-[11px_20px] text-[13px] font-[500] text-[#495159] inline-block mr-[10px]'
                                  key={idx}
                                >
                                  <p className='mb-[5px]'>
                                    <span className='mr-[15px] min-w-[90px] inline-block'>
                                      Fee amount {idx + 1}
                                    </span>
                                    <span className='text-[#263238] font-[500]'>
                                      $ {item.admin_fee}
                                    </span>
                                  </p>
                                  <p>
                                    <span className='mr-[15px] min-w-[90px] inline-block'>
                                      Loan amount
                                    </span>
                                    <span className='text-[#263238] font-[500]'>
                                      $ {item.minimum_loan_amount}
                                    </span>
                                    <span className='mx-[7px]'>to</span>
                                    <span className='text-[#263238] font-[500]'>
                                      $ {item.maximum_loan_amount}
                                    </span>
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                          {item.has_incentive ? (
                            <div className='mt-[15px]'>
                              <label className='block text-[#27272B] font-[700] text-[13px] mb-[8px]'>
                                Incentive
                              </label>
                              <p className='text-[13px] mb-[4px]'>
                                {item.incentive_type === 1 ? '' : '$'}{' '}
                                {item.incentive_amount}
                                {item.incentive_type === 1 ? '%' : ''}
                              </p>
                            </div>
                          ) : null}
                          <div className='mt-[15px]'>
                            <label className='block text-[#27272B] font-[700] text-[13px] mb-[12px]'>
                              Remarks
                            </label>
                            <p className='text-[#787486] text-[12px] mb-[4px]'>
                              {item.remarks1.substring(0, 100)}
                              {item.remarks1.length > 100 ? '..' : null}
                            </p>
                            <p className='text-[#787486] text-[12px] mb-[4px]'>
                              {item.remarks2.substring(0, 100)}
                              {item.remarks2.length > 100 ? '..' : null}
                            </p>
                          </div>
                          {/* {item.agentbonuses &&
                            item.agentbonuses.length > 0 && (
                              <div className='mt-[25px]'>
                                {item.agentbonuses.map((item, idx) => {
                                  return (
                                    <BonusCard
                                      key={idx}
                                      cardData={item.bonusinfo}
                                    />
                                  );
                                })}
                              </div>
                            )} */}
                        </div>
                      );
                    })
                  ) : (
                    <h2 className='text-center mt-[50px] font-[700] text-[25px]'>
                      No Agent Loan Commision
                    </h2>
                  )}
                </>
              )}
            </div>
          </div>
        </ProductInfoContext.Provider >
      )}
    </>
  );
};

export default SingleLoanProduct;
